import queryString from 'query-string';
import { DEFAULT_PAGE_SIZE } from '../../../common/constants';
import type {
	IssueTypeScreenSchemesFilter,
	GetIssueTypeScreenSchemesRequestParams,
} from '../types';

export const defaultFilter: IssueTypeScreenSchemesFilter = {
	pageNumber: 1,
	pageSize: DEFAULT_PAGE_SIZE,
	expand: ['projects'],
	orderBy: 'name',
};

const buildQueryString = (filterParams?: IssueTypeScreenSchemesFilter): string => {
	const {
		pageSize = DEFAULT_PAGE_SIZE,
		pageNumber = 1,
		expand,
		searchFilter,
		orderBy,
	} = filterParams || {};
	const maxResults = pageSize;
	const startAt = (pageNumber - 1) * pageSize;

	let requestParams: GetIssueTypeScreenSchemesRequestParams = { startAt, maxResults };

	if (expand != null) {
		requestParams = { ...requestParams, expand: expand.join(',') };
	}

	if (searchFilter != null && searchFilter.length !== 0) {
		requestParams = { ...requestParams, queryString: searchFilter };
	}

	if (orderBy != null) {
		requestParams = { ...requestParams, orderBy };
	}

	return queryString.stringify(requestParams);
};
export const buildCreateIssueTypeScreenSchemesUrl = (): string =>
	'/rest/api/3/issuetypescreenscheme';

export const buildFetchIssueTypeScreenSchemesUrl = (
	filterParams?: IssueTypeScreenSchemesFilter,
): string => `/rest/api/3/issuetypescreenscheme?${buildQueryString(filterParams)}`;

export const buildIssueTypeScreenSchemeJSPUrl = (issueTypeScreenSchemeId: string): string =>
	`/secure/admin/ConfigureIssueTypeScreenScheme.jspa?id=${issueTypeScreenSchemeId}`;

export const buildConfigureIssueTypeScreenSchemeJSPUrl = (
	issueTypeScreenSchemeId: string,
): string => `/secure/admin/ConfigureIssueTypeScreenScheme.jspa?id=${issueTypeScreenSchemeId}`;

export const buildEditIssueTypeScreenSchemeJSPUrl = (issueTypeScreenSchemeId: string): string =>
	`/secure/admin/EditIssueTypeScreenScheme!default.jspa?id=${issueTypeScreenSchemeId}`;

export const buildCopyIssueTypeScreenSchemeJSPUrl = (issueTypeScreenSchemeId: string): string =>
	`/secure/admin/ViewCopyIssueTypeScreenScheme.jspa?id=${issueTypeScreenSchemeId}`;

export const buildDeleteIssueTypeScreenSchemeJSPUrl = (issueTypeScreenSchemeId: string): string =>
	`/secure/admin/ViewDeleteIssueTypeScreenScheme.jspa?id=${issueTypeScreenSchemeId}`;

export const buildProjectJSPUrl = (projectKey: string): string =>
	`/plugins/servlet/project-config/${projectKey}/summary`;
